import React, { useState, useEffect } from 'react';

import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';
import { Levels, Spinner } from 'react-activity';

import { faWallet, faCreditCard, faUpload, faSave, faSync  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CardView from './components/card-view.js';


import handleMessage from './includes/handle-message.js';
import loadDriver from './includes/load-driver.js';
import openExplorer from './includes/open-explorer.js';
import downloadReceipt from './includes/download-receipt.js';
import getStatusString from './includes/get-status-string.js';
import getTxHashContext from './includes/get-tx-hash-context.js';
import getWidgetSelf from './includes/get-widget-self.js';
import constructTokenAmount from './includes/construct-token-amount.js';
import payAmount from './includes/pay-amount.js';
import openLoadCard from './includes/open-load-card.js';
import openLocalWallet from './includes/open-local-wallet.js';


const WIDGET_NAME = 'pay';
const SETTINGS_ENTRY_STUB = 'widget.pay.';


const PayWidget = ({app, uuid}) => {
	const theapp = app;
	const widget_uuid = uuid;
	const getWidgetUUID = () => {return widget_uuid;};

	const mvcmywidget = theapp.getMvcMyWidget();

	var currentscheme;
	var setCurrentScheme = (scheme) => {currentscheme = scheme};

	var currentcard;
	var setCurrentCard = (card) => {currentcard = card};
	
	var currency;
	var setCurrency = (ccy) => {currency = ccy};

	var ischecking = false;
	var setIsChecking= (val) => { ischecking = val};

	const [navcheck, setNavCheck] = useState(null);

	const [isenabled, setIsEnabled] = useState(true);
	const [isloading, setIsLoading] = useState(false);
	const [isprocessing, setIsProcessing] = useState(false);

	const [widgetsize, setWidgetSize] = useState('small');

	const [widgetview, setWidgetView] = useState('default');

	const [showlocalwallet, setShowLocalWallet] = useState(true);
	const [showremotewallet, setShowRemoteWallet] = useState(true);

	const [balance, setBalance] = useState('');
	const [balance_string, setBalanceString] = useState('');

	// payment transaction
	const [to_address, setToAddress] = useState(null);
	
	const [amount, setAmount] = useState(0);
	const [amount_string, setAmountString] = useState('');
	
	const [invoice_id, setInvoiceId] = useState('');


	// reporting transaction
	const [tx_info, setTransactionInfo] = useState(null);


	// post rendering functions
	const checkCurrencyContext = async () => {
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false};

		try {
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);
		}
		catch(e) {
			console.log('exception in PayWidget.checkCurrencyContext: ' + e);
		}

		return context;
	}

	const computeTokenAmount = async (amount) => {
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

		return constructTokenAmount(theapp, settings_entry, amount);
	}



	// 
	const onPay = async () => {
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		// can proceed
		let canPay = (isenabled ? true : false);

		if ((start_conditions.ask_before_pay === true) || (start_conditions.ask_before_pay === 'true')) {
			// client asked to be consulted
			let answer_struct = await theapp.sendParent({action: 'can_pay'});

			if (answer_struct && (answer_struct.can_pay !== undefined)) 
				canPay = answer_struct.can_pay;
		}

		if (!canPay)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false};

		setIsProcessing(true);


		try {
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);

			
			let rootsessionuuid = await theapp.getRootSessionUUID();
			let devicewallet = await theapp.getDeviceWallet();
			let walletuuid = devicewallet.uuid;

		
			// check address
			let validaddress = await mvcmywidget.isValidAddress(rootsessionuuid, to_address)
			.catch(err => {
				console.log('error in PayWidget.onPay: ' + err);
			});

			if (!validaddress) {
				theapp.alert('This address is not valid');
				setIsProcessing(false);
				return;
			}

			let tx_fee = {};
			tx_fee.transferred_credit_units = 0;
			let transfer_cost_units = 3;
			tx_fee.estimated_cost_units = transfer_cost_units;

			let _feelevel = await mvcmywidget.getRecommendedSchemeFeeLevel(rootsessionuuid, walletuuid, currentscheme.uuid, tx_fee);


			if (currency.ops.cantxfree !== true) {
				if (currency.ops.cantopup === true) {
					// we top-up pretrade card to be sure being able to send a transaction
					const topupinfo = await mvcmywidget.topUpCard(rootsessionuuid, walletuuid, currentcard.uuid)
					.catch(err => {
						console.log('error in PayWidget.onPay: ' + err);
					});
			
					if ((!topupinfo) || (!topupinfo.top) ) {
						theapp.alert('Could not top up account to register quote. Wait a few seconds and try again.');
						setIsProcessing(false);
						return;
					}
					else {
						let transactioninfo = await mvcmywidget.getSchemeTransactionInfo(rootsessionuuid, currentcard.schemeuuid);
		
						if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
							theapp.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
							setIsProcessing(false);
							return;
						}
					}
				}

				// check we have enough transaction credits
				let _currentcard_privatekey = await mvcmywidget.getCardPrivateKey(rootsessionuuid, walletuuid, currentcard.uuid);

				var canspend = await mvcmywidget.canCompleteSchemeTransaction(rootsessionuuid, walletuuid, currentscheme.uuid, _currentcard_privatekey, tx_fee, _feelevel)
				.catch(err => {
					console.log('error in PayWidget.onPay: ' + err);
				});

				if (!canspend) {
					if (tx_fee.estimated_fee.execution_credits > tx_fee.estimated_fee.max_credits) {
						theapp.alert('The execution of this transaction is too large: ' + tx_fee.estimated_fee.execution_units + ' credit units.');
						setIsProcessing(false);
						return;
					}
					else {
						theapp.alert('You must add transaction units to the source card. You need at least ' + tx_fee.required_units + ' credit units.');
						setIsProcessing(false);
						return;
					}
				}

			}

			// check the balance is high enough
	
			let tokenamount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currency.uuid, amount);
			let tokenamount_int = await tokenamount.toInteger();

			var currencyposition = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid);
			var tokenamountmax = await currencyposition.toInteger();
	
			if (tokenamount_int > tokenamountmax) {
				theapp.alert('You must add amount to your balance.');
				setIsProcessing(false);
				return;
			}
	
			// perform payment
			let txhash_payment = await mvcmywidget.payAmount(rootsessionuuid, walletuuid, currentcard.uuid, to_address, currency.uuid, tokenamount_int, _feelevel)
			.catch(err => {
				console.log('error in PayWidget.onPay: ' + err);
			});

			if (txhash_payment) {
				let remotewallet = await loadDriver(theapp);

				let _tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, txhash_payment);

				putTransactionInfo(_tx_info);

				// send event to parent
				theapp.postParent({action: 'receive_event', event_name: 'on_pay', tx_info: _tx_info});
			}
			else {
				theapp.alert('Could not transfer amount');
				setIsProcessing(false);
				return;
			}

			context._refresh_page = true;
		}
		catch(e) {
			console.log('exception in PayWidget.checkNavigationState: ' + e);
		}
		finally {
			console.log('final statements in PayWidget.checkNavigationState');
			setIsProcessing(false);

			// refresh page, if required
			if (context._refresh_page)					
			theapp.refreshPage();
		}
	
			
	}

	const doAmountTransfer = async (amnt, address, widget_uuid) => {

		let tx_info;

		try {
			let rootsessionuuid = await theapp.getRootSessionUUID();
			let devicewallet = await theapp.getDeviceWallet();
			let walletuuid = devicewallet.uuid;

			// format to currency
			const currency_amount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currency.uuid, amnt);
			var options = {showdecimals: true, decimalsshown: 4}
			const currency_amount_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, currency_amount, options);

			// we ask the user if they authorize the transfer
			let question = theapp.t('Do you authorize the transfer of');
			question += ' ';

			question += currency_amount_string;
			question += ' ';

			question += theapp.t('to');
			question += ' ';

			question += address;
			question += ' ';

			question += '?';

			var accept = await theapp.confirm(question);

			// do transfer if accepted
			if (accept == true) {
				tx_info = await payAmount(theapp, currentscheme, currentcard, currency, amnt, address);
			}
		}
		catch(e) {
			console.log('exception in PayWidget.doAmountTransfer: ' + e);
		}


		return tx_info;
	}

	const onRefresh = async () => {
		if (tx_info && tx_info.hash) {
			// note: duplicated in onRefreshPage but kept here to avoid possible regressions (2021.11.11)

			try {
				// make sure currentscheme, currency and currentcard are filled
				let context = await checkCurrencyContext();
	
				let rootsessionuuid = await theapp.getRootSessionUUID();
				let devicewallet = await theapp.getDeviceWallet();
				let walletuuid = devicewallet.uuid;
	
				let remotewallet = await loadDriver(theapp);
	
				let _tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, tx_info.hash);
	
				putTransactionInfo(_tx_info);

			}
			catch(e) {
				console.log('exception in PayWidget.onRefresh: ' + e);
			}

		}

		theapp.refreshPage();
	}

	const onLoadCard = async () => {

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;
		
		var base_uri = await theapp.getRemoteWalletUrl();
		var uri;

		// load card from remote wallet

		// make sure currentscheme, currency and currentcard are filled
		let context = await checkCurrencyContext();
	

		return openLoadCard(theapp, context, amount);
	}


	const onOpenWallet = async () => {
		console.log('PayWidget.onOpenWallet called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;
		
		// make sure currentscheme, currency and currentcard are filled
		let context = await checkCurrencyContext();
	

		return openLocalWallet(theapp, context);
	}

	const onHandleMessage = async (eventname, params) => {
		// onHandleMessage is equivalent to a static function
		// since it is registered in useEffect and correspond
		// to the first call to PayWidget
		if (!params)
			return;

		let mutable = theapp.isMutable();
	
		switch(params.action) {
			case 'getWidgetInfo': {
				let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);

				let amount = self.amount;
				let to_address = self.to_address;
				let web3_provider_url = (currentscheme && currentscheme.network && currentscheme.network.ethnodeserver ? currentscheme.network.ethnodeserver.web3_provider_url : null)
				let card_address = (currentcard ? currentcard.address : null);
				let token_address = (currency ? currency.address : null);;

				theapp.answerRequest(params, {amount, to_address, web3_provider_url, card_address, token_address});
			}
			break;

			case 'setAmount':		
				if (mutable)
				onAmountChange(params.amount, params.widget_uuid);
				break;
			case 'getAmount': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params, {amount: self.amount});
				}
				break;

			case 'setToAddress':
				if (mutable)
				onToAddressChange(params.address, params.widget_uuid);
				break;
			case 'getToAddress': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params, {to_address: self.to_address});
				}
				break;
	
			case 'getCardAddress': {
					if (!currentcard) {
						let context = await checkCurrencyContext();
					}
					let card_address = (currentcard ? currentcard.address : null);
					theapp.answerRequest(params, {card_address});
				}
				break;
			case 'getCardPublicKeys': {
					let public_keys = (currentcard ? currentcard.publickeys : null);
					theapp.answerRequest(params, public_keys);
				}
				break;
			case 'getCardBalance': {
					let mvcmywidget = theapp.getMvcMyWidget();
					let rootsessionuuid = await theapp.getRootSessionUUID();
					let devicewallet = await theapp.getDeviceWallet();
					let walletuuid = devicewallet.uuid;
		
					var card_balance = {};

					// currency balance
					let _pos = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid).catch(err => {});
						
					if (_pos !== undefined) {
						let _card_balance_int = await _pos.toInteger();
						let _card_balance_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, _pos);

						card_balance.balance = _card_balance_int;
						card_balance.balance_string = _card_balance_string;
					}

					// transaction units
					let _card_credit_balance = await mvcmywidget.getCardCreditBalance(rootsessionuuid, walletuuid, currentcard.uuid).catch(err => {});

					if (_card_credit_balance) {
						card_balance.transaction_units = _card_credit_balance.transactionunits;
					}

					theapp.answerRequest(params, card_balance);
				}
				break;
			
		
			case 'enableWidget':
				setIsEnabled(true);
				theapp.answerRequest(params, {enabled:true});
				break;
			case 'disableWidget':
				setIsEnabled(false);
				theapp.answerRequest(params, {enabled:false});
				break;
			case 'isEnabled': {
					let flag = (isenabled === true ? true : false);
					theapp.answerRequest(params, {enabled:flag});
				}
				break;
	
				
			case 'getInvoiceId': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params, {invoice_id: self.invoice_id});
				}
				break;

			case 'setInvoiceId':
				onInvoiceIdChange(params.invoiceid);
				break;

			case 'getTransactionInfo': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params, self.tx_info);
				}
				break;
			case 'setTransactionHash':
				onTransactionHashChange(params.transaction_hash, params.widget_uuid);
				break;


			// request for actions
			case 'doAmountTransfer': {
				let tx_info = await doAmountTransfer(params.amount, params.to_address, params.widget_uuid);
				theapp.answerRequest(params, {tx_info});
			}
			break;

			case 'doLoadCard': {
				await onLoadCard();
			}
			break;

			case 'doOpenWallet': {
				await onOpenWallet();
			}
			break;

			// support api
			default: {
					let start_conditions = theapp.getStartConditions();
					if (!start_conditions) return;
					let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;
					handleMessage(theapp, settings_entry, params);
				}
				break;
		}
	}

	const onRefreshPage = async (eventname, params) => {
		// onRefreshPage is equivalent to a static function
		// since it is registered in useEffect and correspond
		// to the first call to PayWidget
		console.log('PayWidget.onRefreshPage called');

		if (!ischecking) {
			console.log('calling checkNavigationState after page refresh');
			await checkNavigationState();
		}
		else {
			console.log('ischecking==true, not calling checkNavigationState');
		}


		try {
			// check if we have set a txinfo in the widget (directly or by onPay)
			let _tx_info = (tx_info ? tx_info : fetchTransactionInfo());

			if (_tx_info && _tx_info.hash) {
				// make sure currentscheme, currency and currentcard are filled
				let context = await checkCurrencyContext();

				let rootsessionuuid = await theapp.getRootSessionUUID();
				let devicewallet = await theapp.getDeviceWallet();
				let walletuuid = devicewallet.uuid;

				let remotewallet = await loadDriver(theapp);

				_tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, _tx_info.hash);

				putTransactionInfo(_tx_info);
			}

		}
		catch(e) {
			console.log('exception in PayWidget.onRefreshPage: ' + e);
		}


		return;
	}

	const checkNavigationState = async () => {
		console.log('PayWidget.checkNavigationState called');

		setIsLoading(true);
		setIsChecking(true);
	
		let mvcmywidget = theapp.getMvcMyWidget();
		var start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false};

		try {
			let rootsessionuuid = await theapp.getRootSessionUUID();
			let devicewallet = await theapp.getDeviceWallet();
			let walletuuid = devicewallet.uuid;
	
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);


			if (currency && currentcard) {
				// TODO: this can create a hanging problem because of the 'load promise on the backburner' of ethereum_core's ContractInstance
				let _pos = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid);
						
				if (_pos !== undefined) {
					let _card_balance_int = await _pos.toInteger();
					let _card_balance_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, _pos);
						
					if (balance != _card_balance_int)
					setBalance(_card_balance_int);

					if (balance_string != _card_balance_string)
					setBalanceString(_card_balance_string);
				}
			}

			if (start_conditions.caller && currentscheme) {
				let tx_hash = getTxHashContext(theapp);

				if (tx_hash) {
					let remotewallet = await loadDriver(theapp);

					let _tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, tx_hash);

					putTransactionInfo(_tx_info);
				}
			}

			if ((start_conditions.disabled === true) || (start_conditions.disabled === 'true')){
				// specified to start disabled
				setIsEnabled(false);
			}

			if (start_conditions.amount) {
				// a default amount has been set
				onAmountChange(start_conditions.amount);
			}
			else if (start_conditions.string_amount && (start_conditions.string_amount > 0)) {
				let tokenamount = await computeTokenAmount( start_conditions.string_amount);

				if (tokenamount !== undefined)
				onAmountChange(tokenamount);
			}

			if (start_conditions.to_address) {
				// a default recipient has been set
				onToAddressChange(start_conditions.to_address);
			}

			if ((start_conditions.local_wallet_hide === true) || (start_conditions.local_wallet_hide === 'true')){
				// specified to hide access to local wallet
				setShowLocalWallet(false);
			}

			if ((start_conditions.remote_wallet_hide === true) || (start_conditions.remote_wallet_hide === 'true')){
				// specified to hide access to remote wallet
				setShowRemoteWallet(false);
			}

			// widget size
			let widgetsize = theapp.getWidgetSize();

			if (widgetsize != 'small')
			console.log('warning: we handle only the small widget formart for the moment!');

			// alternative views
			if (start_conditions.widget_view && (start_conditions.widget_view !== 'default')){
				// specified to show card view
				setWidgetView(start_conditions.widget_view);
			}



			// signal we are loaded
			await mvcmywidget.signalEvent('on_widgetloaded_message', {widget_name: WIDGET_NAME});

		}
		catch(e) {
			console.log('exception in PayWidget.checkNavigationState: ' + e);
		}
		finally {
			console.log('final statements in PayWidget.checkNavigationState');
			setIsLoading(false);
			setIsChecking(false);

			setNavCheck({currentscheme, currentcard, currency});

			// refresh page, if required
			if (context._refresh_page)					
			theapp.refreshPage();
		}

	}
  

	useEffect(() => {
		console.log('PayWidget.useEffect called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let _uuid = mvcmywidget.guid();

		checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err)});

		mvcmywidget.registerEventListener('on_handle_message', _uuid, onHandleMessage);
		mvcmywidget.registerEventListener('on_refreshPage', _uuid, onRefreshPage);
		return () => {
			mvcmywidget.unregisterEventListener('on_refreshPage', _uuid);
			mvcmywidget.unregisterEventListener('on_handle_message', _uuid);
		};
	}, []);


	// API
	const fetchTransactionInfo = (widgetuuid) => {
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		return self.tx_info;
	}

	const putTransactionInfo = (txinfo, widgetuuid) => {
		// set in state
		setTransactionInfo(txinfo);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.tx_info = txinfo;
	}

	const onTransactionHashChange = async (txhash, widgetuuid) => {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		if (!currentscheme) {
			await checkNavigationState();
		}

		let remotewallet = await loadDriver(theapp);

		let _tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, txhash);

		putTransactionInfo(_tx_info, widgetuuid);
	}

	// user inputs
	const putAmount = (amnt, widgetuuid) => {
		setAmount(amnt);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.amount = amnt;
	}

	const onAmountChange = async (amnt) => {
		let start_conditions = theapp.getStartConditions();

		if (start_conditions && (start_conditions.amount) && (start_conditions.amount != amnt))
		return; // default has been set and can not be modified for security reasons
		

		if (!currency)
			return;
			
		var mvcmywidget = theapp.getMvcMyWidget();

		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		// we can check valid amount

		// format to currency
		const currency_amount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currency.uuid, amnt);
		var options = {showdecimals: true, decimalsshown: 4}
		const currency_amount_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, currency_amount, options);


		putAmount(amnt);
		setAmountString(currency_amount_string);
	}


	const putToAddress = (address, widgetuuid) => {
		setToAddress(address);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.to_address = address;
	}

	const onToAddressChange = async (address) => {
		let start_conditions = theapp.getStartConditions();

		if (start_conditions && (start_conditions.to_address) && (start_conditions.to_address != address))
		return; // default has been set and can not be modified for security reasons

		// we can check it is a valid address

		putToAddress(address);
	}

	const putInvoiceId = (id, widgetuuid) => {
		setInvoiceId(id);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.invoice_id = id;
	}

	const onInvoiceIdChange = async (id) => {
		putInvoiceId(id);
	}

	// rendering
	const renderLoading = () => {
		return (
			<div className="PayWidgetBlock">
				<div>{theapp.t('loading widget...')}</div>
				<div className="PayWidgetLoadingBlock">
					<Levels />
				</div>
			</div>
		);
	}


	
	//
	// Small Size
	//
	const renderTransactionSmall = () => {
		return (
			<div className="sw-PaymentLinkWidgetBlock">

				<div className="sw-PaymentLinkRefreshIcon">
						<FontAwesomeIcon 
						icon={faSync}
						onClick={onRefresh}
						/>
				</div>

				<div className="sw-PaymentLinkAmountLine">
					<span><FormLabel>{theapp.t('Amount')}</FormLabel></span>
					<span className="sw-PaymentLinkAmountInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={(tx_info.amount_string ? tx_info.amount_string : '')}
					/></span>
				</div>

				<div className="sw-PayBalanceLine">
					<span><FormLabel>{theapp.t('Balance')}</FormLabel></span>
					<span className="sw-PayBalanceInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={balance_string}
					/></span>
				</div>

{/* 				<div className="sw-PaymentLinkToAddressLine">
					<span><FormLabel>{theapp.t('Send to')}</FormLabel></span>
					<span className="sw-PaymentLinkToAddressInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={(tx_info.to_address ? theapp.getMvcMyWidget().fitString(tx_info.to_address, 24) : '')}
					/></span>
				</div>
 */}
				<div className="sw-PaymentLinkTxHashLine">
					<span><FormLabel>{theapp.t('TxHash')}</FormLabel></span>
					<span className="sw-PaymentLinkTxHashLink" onClick={() => {openExplorer(theapp, tx_info);}}>{(tx_info.hash ? theapp.getMvcMyWidget().fitString(tx_info.hash, 28) : '')}</span>
				</div>
		
		
				<div className="sw-PaymentLinkTxStatusLine">
					<span><FormLabel>{theapp.t('Status')}</FormLabel></span>
					<span className="sw-PaymentLinkTxStatusInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={getStatusString(theapp, tx_info.status_int)}
					/></span>
					<span id="receipt-icon" className="sw-PaymentLinkTxReceiptIcon">
						<FontAwesomeIcon 
						icon={faSave}
						onClick={() => {downloadReceipt(theapp, tx_info);}}
						/>
					</span>

				</div>
		
				{(showlocalwallet ? 
				<div className="sw-PaymentLinkOpenWalletLine">
					<span className="sw-PaymentLinkOpenWalletIcon">
						<FontAwesomeIcon 
						icon={faCreditCard}
						onClick={onOpenWallet}
						/>
					</span>
				</div> :
				<></>)}

				<div className="sw-PaymentLinkVersionInfo" >{theapp.current_version}</div>
			</div>
		);
	}
	
	const renderCardSmall = () => {

		if (!navcheck)
		return (<div>{renderLoading()}</div>);

		return (
			<div className="sw-PaymentLinkWidgetBlock">
				<CardView
					app={theapp}
					scheme={navcheck.currentscheme}
					card={navcheck.currentcard}
					currency={navcheck.currency}
					size='small'
				/>
			</div>
			);
	}


	const renderPaySmall = () => {
		return (
			<div className="sw-PayWidgetBlock">
				
				<div className="sw-PayRefreshIcon">
						<FontAwesomeIcon 
						icon={faSync}
						onClick={onRefresh}
						/>
				</div>

				<div className="sw-PayAmountLine">
					<span><FormLabel>{theapp.t('Amount')}</FormLabel></span>
					<span className="sw-PayAmountInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={amount_string}
					/></span>
				</div>


				<div className="sw-PayBalanceLine">
					<span><FormLabel>{theapp.t('Balance')}</FormLabel></span>
					<span className="sw-PayBalanceInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={balance_string}
					/></span>
				</div>

{/*				<div className="sw-PayInvoiceIdLine">
					<span><FormLabel>{theapp.t('Invoice Id')}</FormLabel></span>
					<span className="sw-PayInvoiceIdInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={invoice_id}
					/></span>
				</div>

 				<div className="sw-PayToAddressLine">
					<span><FormLabel>{theapp.t('Send to')}</FormLabel></span>
					<span className="sw-PayToAddressInput"><FormControl
						autoFocus
						type="text"
						value={to_address}
						onChange={e => onToAddressChange(e.target.value)}
					/></span>
				</div>
 */}
				<Button  className="sw-PayButton"
					onClick={onPay} 
					disabled={(isenabled ? false : true)}
					type="submit">
					{(!isprocessing ? theapp.t('Pay') : <Spinner />)} 
				</Button>

		
				<div className="sw-PayOpenWalletLine">
					{(showremotewallet ? 
					<span className="sw-PayLoadCardIcon">
						<FontAwesomeIcon 
						icon={faUpload}
						onClick={onLoadCard}
						/>
					</span> :
					<></>)}
					{(showlocalwallet ? 
					<span className="sw-PayOpenWalletIcon">
						<FontAwesomeIcon 
						icon={faCreditCard}
						onClick={onOpenWallet}
						/>
					</span> :
					<></>)}
				</div>
		
				<div className="sw-PayVersionInfo" >{theapp.current_version}</div>

			</div>
		
		);
	}	

	const renderWidget = () => {
		switch(widgetsize) {
			default: {
				if (tx_info)
				return renderTransactionSmall();

				switch(widgetview) {
					case 'cardview':
						return renderCardSmall();
					default:
						return renderPaySmall();
				}

			}
			break;
		}
	}
	
	return (
		<div className="PayWidget">
			{(isloading ? renderLoading() :
			renderWidget())}
		</div>

	);
}

export default PayWidget;
